/**
 * @file genders.ts
 * @brief Gender options for session participants.
 *
 * @author DES
 * @date 19-06-2026
 */

export type GenderOption = { code: string; label: string };

export const GENDERS: GenderOption[] = [
  { code: "male", label: "Male" },
  { code: "female", label: "Female" },
  { code: "other", label: "Other" },
  { code: "prefer_not_to_say", label: "Prefer not to say" },
];
